import DataGridTableSkeleton from "../../../components/skeletons/DataGridTableSkeleton";

export default function RequestedProductsListSkeleton() {
  return (
    <DataGridTableSkeleton height={500} rowCount={10} />
  );
}
